import React from 'react'
import { useNavigate } from 'react-router-dom'
import { cn } from '../../lib/utils'

interface BreadcrumbItemProps {
  href?: string
  state?: unknown
  isLast?: boolean
  children: React.ReactNode
  className?: string
}

export const BreadcrumbItem = ({ href, state, isLast, children, className }: BreadcrumbItemProps) => {
  const navigate = useNavigate()

  if (isLast) {
    return (
      <span className={cn("text-[13px] text-gray-800 font-medium", className)}>
        {children}
      </span>
    )
  }

  return (
    <button
      onClick={() => href && navigate(href, state != null ? { state } : {})}
      className={cn(
        "text-[13px] text-gray-500 font-medium hover:text-primary-500 transition-colors",
        className
      )}
    >
      {children}
    </button>
  )
}

interface BreadcrumbProps {
  items: {
    label: string
    href?: string
    state?: unknown
  }[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav className={cn("flex items-center space-x-2", className)}>
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          <BreadcrumbItem
            href={item.href}
            state={item.state}
            isLast={index === items.length - 1}
          >
            {item.label}
          </BreadcrumbItem>
          {index < items.length - 1 && (
            <span className="text-[13px] text-gray-400">/</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
} 